import { Component } from '@angular/core';
import { isArrayWithData } from '../../utilities/array.helpers';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { Creditor } from '../../interfaces/creditor.interface';
import { AppService } from '../../app.service';
import { AutomationService } from '../../services/automation/automation.service';
import { catchError, finalize, firstValueFrom, tap } from 'rxjs';

@Component({
    selector: 'app-automation-freeze',
    templateUrl: './automation-freeze.component.html',
    styleUrl: './automation-freeze.component.css',
})
export class AutomationFreezeComponent {
    constructor(
        private etlIngestionService: EtlIngestionService,
        private appService: AppService,
        private automationService: AutomationService,
    ) {}

    allCreditors: Creditor[] = [];
    frozenCreditors: number[] = [];
    isSideBarVisible: boolean = false;
    isShowDeleteModal: boolean = false;
    creditorToDelete?: Creditor;
    creditorToAdd?: Creditor;
    selectedCreditor?: Creditor;

    onSelectCreditor(event: Creditor) {
        this.creditorToAdd = event;
        this.onConfirmAdd();
    }

    ngOnInit() {
        this.appService.isShowPageSpinner = true;
        this.etlIngestionService
            .getCreditors()
            .pipe(
                tap(async (res: any) => {
                    if (isArrayWithData(res?.Creditors)) {
                        this.allCreditors = res.Creditors;
                        await this.getFrozenCreditors();
                    } else {
                        this.appService.isShowPageSpinner = false;
                    }
                }),
                catchError((error: any) => {
                    this.appService.isShowPageSpinner = false;
                    return this.appService.handleError(error);
                }),
                finalize(() => {}),
            )
            .subscribe();
    }

    get frozenCreditorsDisplay() {
        return this.allCreditors.filter((c: Creditor) =>
            this.frozenCreditors.includes(parseInt(c.CreditorId)),
        );
    }

    get creditorOptions() {
        return this.allCreditors.filter(
            (c: Creditor) =>
                !this.frozenCreditors.includes(parseInt(c.CreditorId)),
        );
    }

    async getFrozenCreditors() {
        this.appService.isShowPageSpinner = true;
        this.automationService
            .getFrozenCreditors()
            .pipe(
                tap((res: any) => {
                    if (isArrayWithData(res)) {
                        this.frozenCreditors = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    }

    getMockFrozenCreditors() {
        this.frozenCreditors = [10, 96, 14, 128, 110];
    }

    onClickAdd() {
        this.isSideBarVisible = true;
        this.selectedCreditor = undefined;
    }

    onDelete(creditorToDelete: Creditor) {
        this.creditorToDelete = creditorToDelete;
        this.isShowDeleteModal = true;
    }

    onConfirmDelete() {
        if (this.creditorToDelete?.CreditorId) {
            this.appService.isShowPageSpinner = true;
            this.automationService
                .postFreezeUnFreezeCreditor(
                    this.creditorToDelete?.CreditorId,
                    false,
                )
                .pipe(
                    tap((res: any) => {
                        if (isArrayWithData(res)) {
                            this.frozenCreditors = res;

                            // this.frozenCreditors = this.frozenCreditors.filter(
                            //     (c: number) =>
                            //         c !==
                            //         parseInt(
                            //             this.creditorToDelete?.CreditorId!,
                            //         ),
                            // );
                            this.appService.showCommonMessageDialog(
                                'Success',
                                this.creditorToDelete?.CompanyName +
                                    ' is successfully removed from the Frozen Creditors List.',
                            );
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                    }),
                )
                .subscribe();
        }
    }

    onConfirmAdd() {
        if (this.creditorToAdd?.CreditorId) {
            this.appService.isShowPageSpinner = true;
            this.automationService
                .postFreezeUnFreezeCreditor(
                    this.creditorToAdd?.CreditorId,
                    true,
                )
                .pipe(
                    tap((res: any) => {
                        if (isArrayWithData(res)) {
                            // this.frozenCreditors.push(
                            //     parseInt(this.creditorToAdd?.CreditorId!),
                            // );

                            this.frozenCreditors = res;
                            this.isSideBarVisible = false;
                            this.appService.showCommonMessageDialog(
                                'Success',
                                this.creditorToAdd?.CompanyName +
                                    ' is successfully added to Frozen Creditors List.',
                            );
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                    }),
                )
                .subscribe();
        }
    }
}
